import Plyr from 'plyr';

const VIDEO_SELECTOR = '.wp-block-video, .wp-block-embed';

export const Video = () => {
    document.querySelectorAll(VIDEO_SELECTOR).forEach((el) => {
        // For regular video blocks, get the video element
        let video = el.querySelector('video');
        // For embed blocks (YouTube, Vimeo), get the wrapper that contains the iframe
        let embedWrapper = el.querySelector('.wp-block-embed__wrapper');

        // Determine which element to use
        const mediaElement = video || embedWrapper;

        // Skip if no media element found
        if (!mediaElement) return;

        // Check attributes only on video elements (embeds don't have these)
        const hasControls = video ? video.hasAttribute('controls') : false;
        const hasAutoplay = video ? video.hasAttribute('autoplay') : false;
        const hasMuted = video ? video.hasAttribute('muted') : false;

        const player = new Plyr(mediaElement, {
            controls: video ? (hasControls ? ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'] : []) : ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
            hideControls: false,
        });

        player.on('ready', (event) => {
            const instance = event.detail.plyr;

            if (hasControls) {
                instance.elements.container.parentNode.classList.add('has-controls');
            }

            if (hasMuted) {
                player.muted = true;
                player.volume = 0;
            }

            if (hasAutoplay) {
                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.intersectionRatio > 0 || entry.isIntersecting) {
                                setTimeout(() => {
                                    player.muted = true;
                                    player.volume = 0;
                                    if (!player.playing) {
                                        player.play().catch(() => {
                                            // Handle play rejection silently
                                        });
                                    }
                                }, 100);
                            } else {
                                if (player.playing) {
                                    player.pause();
                                }
                            }
                        });
                    },
                    {
                        root: null,
                        rootMargin: '0px',
                        threshold: 0,
                    },
                );

                observer.observe(instance.elements.container);
            }
        });
    });
};
